import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  AlertController,
  IonContent,
  IonicModule,
  ModalController,
  NavController,
  PopoverController
} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {NativeAudio} from "@capgo/native-audio";
import {PostModel} from 'src/app/models/post.model';
import {PostService} from 'src/app/services/post/post.service';
import {GlobalService} from 'src/app/services/global/global.service';
import {ApiResponse} from 'src/app/services/utils';
import {UserService} from 'src/app/services/user/user.service';
import {AuthService} from 'src/app/services/auth/auth.service';
import {UserModel} from 'src/app/models/user.model';
import {CommentsComponent} from '../comments/comments.component';
import {TagUserComponent} from '../tag-user/tag-user.component';
import {StorageService} from '../../services/storage/storage.service';
import {ShareService} from "../../services/share/share.service";
import {Capacitor} from "@capacitor/core";
import {GalleryModalComponent} from "../../modal/gallery-modal/gallery-modal.component";
import {CommonModule} from "@angular/common";
import {ReadMoreModule} from "../read-more/read-more.module";
import {RouterModule} from "@angular/router";
import {InteractedPeopleModule} from "../interacted-people/interacted-people.module";
import {SetRatingModule} from "../set-rating/set-rating.module";
import {CommentsModule} from "../comments/comments.module";
import {TagUserModule} from "../tag-user/tag-user.module";
import {
  ActionPointMetricComponentComponent
} from "../action-point-metric-component/action-point-metric-component.component";
import {emitDistinctChangesOnlyDefaultValue} from "@angular/compiler";

@Component({
  selector: 'app-post-card',
  templateUrl: './post-card.component.html',
  styleUrls: ['./post-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslatePipe,
    ReactiveFormsModule,
    ReadMoreModule,
    RouterModule,
    InteractedPeopleModule,
    SetRatingModule,
    CommentsModule,
    TagUserModule,
    ActionPointMetricComponentComponent
  ]
})
export class PostCardComponent implements OnInit {
  @Input() content: IonContent;
  @Input() item: PostModel;
  @Input() interaction: string;
  @Input() colorTheme: string = 'normal';
  @Input() page: string;

  @Output() closed = new EventEmitter<void>();

  @ViewChild('commentInputElement') commentInput: ElementRef<HTMLTextAreaElement>;
  @ViewChild(CommentsComponent) commentsComponent: CommentsComponent;
  @ViewChild(TagUserComponent) tagUserComponent: TagUserComponent;
  @ViewChild('footertag') footertag: ElementRef;
  @ViewChild(IonContent, {static: false}) contentPC: IonContent;

  postVisible = true;
  commentBox = false;
  commentForm: UntypedFormGroup;

  subscription: Subscription;

  likeButtonDisabled = false;
  contentY = 0;
  createdTime;
  user: UserModel;

  parentId = 0;
  translateFlag = false;

  readMore = false;
  commentScrollBottom = 'no';

  findIndex = 0;
  tagSelectedFlag = false;
  userSelectedTags: UserModel[] = [];

  adoptPost = true;
  reasonNotAdoptOwn = true;
  totalUsersRatedCount = 0;

  colorOfEarth: string;
  iconMetric: string;
  galleryIsOpen: boolean = true;
  private modalElement?: any;
  public isMobileScreen: boolean = false;
  public showCommentBox: boolean = false;
  public loadingComplete: boolean = false;


  constructor(
    private navController: NavController,
    private postService: PostService,
    public globalService: GlobalService,
    private userService: UserService,
    private auth: AuthService,
    public popoverCtrl: PopoverController,
    private translate: TranslateService,
    private storage: StorageService,
    private alertController: AlertController,
    private shareService: ShareService,
    private modalController: ModalController,
  ) {
    if (window.innerWidth < 500) {
      this.isMobileScreen = true
    }

    this.commentForm = new UntypedFormGroup({
      comment: new UntypedFormControl(
        '', Validators.required
      ),
      commentId: new UntypedFormControl(
        '', null
      )
    });
  }

  resize() {
    this.tagSelectedFlag = false;
    this.commentInput.nativeElement.style.height = 'auto';
    this.commentInput.nativeElement.style.height = this.commentInput.nativeElement.scrollHeight + 'px';
  }

  ngOnInit() {
    if (this.item.type === 'action_point' || this.item.type === 'adopted_action_point') {
      if (this.item.metrics !== undefined) {
        if (this.item.metrics[0].metric.icon !== '') {
          this.iconMetric = this.item.metrics[0].metric.icon;
        }
      } else {
        this.iconMetric = '';
      }
    }
    this.user = this.auth.user;
    this.createdTime = this.globalService.timeSince(this.item?.createdAt);

    this.auth.getUserStatus.subscribe(() => {
      this.user = this.auth.user;
    });
    this.globalService.homeContentEvent.subscribe(val => {
      this.contentY = val;
    });
    this.globalService.languageEvent.subscribe(val => {
      if (val !== '') {
        this.createdTime = this.globalService.timeSince(this.item?.createdAt);
      }
    });
    this.postService.postSubject.subscribe(val => {
      if (val !== null && val.id === this.item?.id) {
        this.item = val;
      }
    });

    this.commentForm.get('comment').valueChanges.subscribe((val: any) => {
      if (val !== null) {
        if (val.lastIndexOf('@') !== -1 && val.lastIndexOf('@') > val.lastIndexOf(' ') && this.tagSelectedFlag === false) {
          this.findIndex = val.lastIndexOf('@');
          const newVal = val.substring(this.findIndex + 1, val.length);
          this.tagUserComponent.getItems(newVal);
        }
        if (val.lastIndexOf('@') === -1) {
          this.tagUserComponent.getItems('');
        }
      }
    });

    this.viewAdopt();
    if ((this.item.type === 'action_point' || this.item.type === 'adopted_action_point') && this.item) {
      this.postService.viewRatingStatistics(this.item.id).subscribe((result: any) => {
        if (result.status) {
          this.totalUsersRatedCount = result.data.totalUsersCount;
          this.setColorOfRatingButton(this.item.star);
        } else {
          console.error(result.error);
        }
      });
    }

    if (this.item.postMeta) {
      if (this.item.postMeta.title !== '') {
        this.item.postMeta.title = this.item.postMeta.title.slice(0, 30) + '...';
      }
    }

    this.shareService.sharedLinkCounter.subscribe({
      next: () => {
        this.item.sharesCount += 1;
      }
    });
  }

  selectedUser(event) {
    this.userSelectedTags.push(event.user);
    this.tagSelectedFlag = true;
    const str = this.commentForm.get('comment').value;
    this.commentForm.get('comment').setValue(
      str.substring(0, this.findIndex) + '@' + event.user.username + ' '
    );

    setTimeout(() => {
      const inputEl = this.commentInput?.nativeElement;
      if (inputEl) {
        const val = inputEl.value.length;
        inputEl.setSelectionRange(val, val);
        inputEl.focus();
      }
    }, 50);
  }


  async openPost(item) {
    await this.navController.navigateForward(['/app/home/view-post/' + item.type + '/' + item?.id + '/detail']);
    this.closed.emit();
  }

  async openPostComment(item) {
    await this.navController.navigateForward(
      ['/app/home/view-post/' + item.type + '/' + item?.id + '/comment'],
      {
        queryParams: {comment: 'true'}
      }
    );
    this.closed.emit();
  }

  async editPost(item) {
    this.popoverCtrl.dismiss();
    if (item.type === 'post') {
      await this.navController.navigateForward(['/app/home/edit-post/' + item?.id]);
      this.closed.emit();
    } else {
      await this.navController.navigateForward(['/app/action-point/edit-action-point/' + item.id]);
      this.closed.emit();
    }
  }

  async openOtherProfile(id) {
    if (!this.item.createdBy.isDeleted) {
      await this.navController.navigateForward(['/app/home/other-profile/' + id]);
      this.closed.emit();
    }
  }

  async openInteraction(item, type) {
    await this.navController.navigateForward(['/app/home/interaction/' + item?.id + '/' + type]);
    this.closed.emit();
  }

  listActionPost(item) {
    if (this.auth && this.auth.isAuthenticated) {
      this.likeButtonDisabled = true;
      const data = {postId: item?.id};

      this.postService.apiLikeActionPoint(data).subscribe(async (result: ApiResponse) => {
        if (result.status) {
          this.item = result.data;

          if (result.data.isLiked && Capacitor.isNativePlatform() && await this.storage.isInteractionSoundOn()) {
            NativeAudio.play({
              assetId: 'like',
              time: 0
            });
          }
        }
        this.likeButtonDisabled = false;
      });
    } else {
      this.isAnonymousAction();
    }
  }

  openLink(url) {
    window.open(url, '_system');
  }

  reportPost(item) {
    this.popoverCtrl.dismiss();
    this.postService.reportPost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.globalService.presentToast(result.message);
      }
    });
  }

  hidePost(item) {
    this.popoverCtrl.dismiss();
    this.postService.hidePost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.postVisible = false;
        this.globalService.presentToast(result.message);
      }
    });
  }

  blockUser(item) {
    this.popoverCtrl.dismiss();
    this.userService.apiBlockUser(item.createdBy.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.auth.userLoggedIn.next('hardreload');
        this.globalService.presentToast(result.message);
      }
    });
  }


  readMoreFun(data: any) {
    this.readMore = data.val === 'yes';
  }

  async setRating(event: any) {
    if (this.totalUsersRatedCount === 0) {
      this.totalUsersRatedCount += 1;
    }
    this.setColorOfRatingButton(event.item.star);
    if (event.popupClose) {
      this.item.isRated = event.item.isRated;
      this.item.star = event.item.star;
    }
    await this.popoverCtrl.dismiss();
  }

  addAdoptActionPoint(item) {
    const data = {postId: item?.id};
    if (this.auth && this.auth.isAuthenticated) {
      if (!item?.isAdopted) {
        this.postService.apiAddAdoptActionPoint(data).subscribe(async (result: ApiResponse) => {
          if (result.status) {
            this.loadActionPost(item.id);
            if (Capacitor.isNativePlatform() && await this.storage.isInteractionSoundOn()) {
              NativeAudio.play({
                assetId: 'adopt',
                time: 0
              });
            }
            if (this.item.company && this.item.action_point_type === 'company') {
              await this.globalService.presentToast(this.translate.instant('txt_ap_adopted_from_company'), 4000);
            } else {
              await this.globalService.presentToast(this.translate.instant('txt_ap_adopted'));
            }
          } else {
            await this.globalService.presentToast(this.translate.instant('err_general'));
          }
        });
      } else {
        this.postService.apiRemoveAdoptAP(data).subscribe(async (result: ApiResponse) => {
          if (result.status) {
            this.loadActionPost(item.id);
            await this.globalService.presentToast(this.translate.instant('txt_ap_unadopted'));
          } else {
            await this.globalService.presentToast(this.translate.instant('err_general'));
          }
        });
      }
    } else {
      this.isAnonymousAction();
    }
  }

  loadActionPost(postId) {
    this.postService.apiGetSingleActionPoint(postId).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.item = result?.data;
      }
    });
  }

  openCompanyProfile(c) {
    if (c?.isAdmin) {
      this.navController.navigateForward(['/app/team/company/view-company/' + c.id]);
      this.closed.emit();
    } else {
      this.navController.navigateForward(['/app/team/company/other-company/' + c.id]);
      this.closed.emit();
    }
  }

  commentSubmit() {
    if (!this.commentForm.valid) {
      this.commentForm.markAllAsTouched();
      return;
    }

    const userTags: number[] = [];
    this.userSelectedTags.forEach(element => {
      if (this.commentForm.value.comment.includes('@' + element.username)) {
        userTags.push(element.id);
      }
    });

    this.commentsComponent.commentSubmit(this.commentForm, userTags);
    this.commentForm.reset();
    this.commentBox = true;
    if (this.item?.commentsCount !== undefined) {
      this.item.commentsCount += 1;
    }

    this.loadComments();

    this.globalService.presentToast(this.translate.instant('txt_comment_got_posted'));
  }

  loadComments() {
    if (this.auth && this.auth.isAuthenticated) {
      this.commentBox = true;

      setTimeout(() => {
        if (this.commentsComponent) {
          this.commentsComponent.loadCommentByComponent();
        }
      }, 100);
    } else {
      this.isAnonymousAction();
    }
  }


  setCommentBoxValue(event) {
    this.commentForm.setValue(event.val);
  }

  cannotAdoptActionPoint() {
    if (this.reasonNotAdoptOwn) {
      this.globalService.presentToast(this.translate.instant('txt_cannot_adopt_your_own'));
    } else {
      this.globalService.presentToast(this.translate.instant('txt_cannot_adopt_company_ap'));
    }
  }

  viewAdopt() {
    if (this.user && this.user.id === this.item.createdBy.id) {
      this.adoptPost = false;
      this.reasonNotAdoptOwn = true;
    } else if (this.user && this.user.id !== this.item.createdBy.id && this.item.company === undefined) {
      this.adoptPost = true;
    }
  }

  async deletePost(item) {
    const alert = await this.alertController.create({
      cssClass: 'remove-action-point-alert',
      header: this.translate.instant('hdl_delete_post'),
      message: this.translate.instant('txt_delete_post'),
      buttons: [
        {
          text: this.translate.instant('lbl_no'),
          role: 'cancel',
          cssClass: 'cancel-button',
          id: 'cancel-button',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('lbl_yes'),
          id: 'confirm-button',
          cssClass: 'confirm-button',
          handler: () => {
            this.apiDeletePost(item);
          }
        }
      ]
    });

    await alert.present();
  }


  apiDeletePost(item) {
    this.popoverCtrl.dismiss();
    this.postService.apiDeletePost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.item = null;
        this.globalService.presentToast(this.translate.instant('txt_post_delete_success'));
      } else {
        this.globalService.presentToast(this.translate.instant('txt_post_delete_failure'));
      }
    });
  }

  setColorOfRatingButton(starsAvg) {
    this.colorOfEarth = this.postService.setRatingColor(starsAvg, this.totalUsersRatedCount);
  }

  async sharePost(item: any) {
    const filepath = item && item.media && item.media[0] && item.media[0].path ? item.media[0].path : '';
    await this.shareService.share(item.id, item.title, item.description, item.shareUrl, filepath);
  }

  isAnonymousAction() {
    if (!(this.user && this.auth.isAuthenticated)) {
      this.globalService.openLoginModal();
    }
  }

  translatePost(event: any) {
    this.translateFlag = event;
  }

  async openGallery(actionPointId: number, momentId: number) {
    this.modalElement = await this.modalController.create({
      component: GalleryModalComponent,
      backdropDismiss: true,
      mode: 'ios',
      id: 'inline-modal',
      cssClass: 'modal-gallery',
      componentProps: {
        momentId: momentId,
        actionPointId: actionPointId,
        actionPointFeed: true
      }
    });
    await this.modalElement.present();
    this.galleryIsOpen = true;
  }

  focusToCommentBar() {
    this.showCommentBox = !this.showCommentBox;
    if (this.user && this.user.id) {
      setTimeout(() => {
        this.commentInput.nativeElement.focus();
      }, 100);
    } else {
      this.isAnonymousAction();
    }
  }

  async openSheetModal() {
    this.showCommentBox = !this.showCommentBox;
  }

  loadMoreComments(event) {
    if (this.item && this.item.commentsCount > 3) {
      this.commentsComponent.loadMoreComments(event);
    } else {
      event.target.complete();
      this.loadingComplete = true;
    }
  }

  virtualScrolled(event: any) {
    event.stopPropagation();
  }

  protected readonly emitDistinctChangesOnlyDefaultValue = emitDistinctChangesOnlyDefaultValue;
}
